const Ratings = () => {
  return (
    <>
      <div className="not-found">
        <h2>Wine Ratings Data Coming Soon...</h2>
      </div>
    </>
  );
};

export default Ratings;
